



























































import { Prop, Component, Vue } from 'vue-property-decorator'
import { User } from '@/api/model/user'
import { availableDashboardViews } from '@/api/types'

@Component
export default class EditUserDetailsForm extends Vue {
    @Prop() readonly user!: User
    loading: boolean = false
    avatarChanged: boolean = false

    get validGenders() {
        return User.validGenders.map(value => ({ label: this.$t(`gender.${value}`), value }))
    }

    get defaultDashboardViewOptions() {
        return availableDashboardViews().map(value => ({
            label: this.$t(`dashboard-view.${value}`),
            subtext: this.$t(`dashboard-view.${value}_subtext`),
            value,
        }))
    }
}

